import React from 'react';
import { Button } from '@tencent/tea-component';
import { useTranslation } from 'react-i18next';
import { HostAudioCtrlProps } from './HostAudioCtrl.type';
import './HostAudioCtrl.scss';
import wemeetClient from '@utils/wemeetClient';
import { BOOL } from '@tencent/wemeet-websdk-next';

const HostAudioCtrl: React.FC<HostAudioCtrlProps> = (props) => {
  const { t } = useTranslation();

  const muteOther = () => {
    const isGrant = props.isMute ? BOOL.false : BOOL.true;
    if (props.user.id) {
      wemeetClient.hostCtrl.muteAudio(props.user.id, isGrant);
    }
  };

  const muteSelf = () => {
    // 操作自己
    if (props.isMute) {
      wemeetClient.mediaCtrl.muteAudio({
        requestUpStreamToken: '',
        needRefreshToken: BOOL.false,
      });
    } else {
      wemeetClient.mediaCtrl.unMuteAudio({
        requestUpStreamToken: '',
        needRefreshToken: BOOL.false,
      });
    }
  };
  const handleMute = () => {
    if (props.isMuteSelf) {
      muteSelf();
    } else {
      muteOther();
    }
  };
  return (
    <Button className="host-audio-ctrl" type={'primary'} onClick={handleMute}>
      {props.isMute ? t('静音') : t('解除静音')}
    </Button>
  );
};

export default HostAudioCtrl;
